define('app/dashboard/DashboardListItemView',['require','glu/itemView','glu/dialog','app/app','./dialogs/EditDashboardDialogView','hbs!./DashboardListItemView.hbs'],function(require) {

	'use strict';

	var ItemView = require('glu/itemView'),
		dialog = require('glu/dialog'),
		App = require('app/app'),
		EditDashboardDialogView = require('./dialogs/EditDashboardDialogView');


	return ItemView.extend({
		template: require('hbs!./DashboardListItemView.hbs'),

		events: {
			'click': 'selectMe',
			'click button': 'toggleMenu',
			'mouseleave .menu': 'closeMenu',
			'click .menu-edit': 'editMe',
			'click .menu-remove': 'deleteMe'
		},

		initialize: function() {
			this.listenTo(this.model, 'change', this.refresh);
			this.listenTo(this.model, 'change:edited', this.render);
			this.dialog = dialog;
		},

		serializeData: function() {
			return this;
		},

		refresh: function() {
			this.$el.parent().toggleClass('active', !!this.model.get('isSelected'));
		},

		selectMe: function(e) {
			e.preventDefault();

			if (!this.model.get('isSelected')) {
				this.model.set('isSelected', true);
				this.model.trigger('change');
			}
		},

		editMe: function() {
			var self = this;
			this.editDashboardView = new EditDashboardDialogView({
				model: this.model,
				className: 'modal-edit-dashboard'
			});

			this.dialog.open(this.editDashboardView);

			this.listenTo(this.editDashboardView, 'editDashboard', function() {
				self.dialog.close();
				this.model.trigger('change:edited');
			});
		},

		deleteMe: function() {
			var dashboard = this.model;
			var msg;
			if (dashboard.get('owner') === App.user.getUsername()) {
				if (dashboard.get('isPrivate') === true) {
					msg = 'Are you sure you want to delete the dashboard "' + this.name() + '"?';
				} else {
					// warn user if it is a public (maybe shared) report
					msg = 'Are you sure you want to delete the dashboard "' + this.name() + '"? This is a public dashboard and is shared with other users. They will not be able to view it, if it is deleted.';
				}
			} else {
				msg = 'Are you sure you want to remove the shared dashoard "' + this.name() + '" from your list of dashboards?';
			}
			this.dialog.confirm(msg,
				'Delete Dashboard',
				function(ok) {
					if (ok) {
						// Logic if 'Yes' is clicked
						dashboard.trigger('change:deleted', dashboard);
					}
				});
		},

		isOwner: function() {
			return this.model.get('owner') === App.user.getUsername();
		},

		toggleMenu: function() {
			this.$el.find('.menu').toggleClass('active');
		},

		closeMenu: function() {
			this.$el.find('.menu').removeClass('active');
		},

		name: function() {
			return this.model.get('name');
		},

		userIsReadOnly: function() {
			return App.user.isReadOnly();
		},

		description: function() {
			return this.model.get('description');
		},

		index: function() {
			return this.model.collection.indexOf(this.model);
		},

		canBeDeleted: function() {
			if (App.user.isInternalUser()) {
				return (this.model.get('dashboardType') === 'CUSTOM' && this.model.get('owner') === App.user.getUsername());
			} else {
				return (this.model.get('dashboardType') === 'CUSTOM');
			}
		},

		dashboardId: function() {
			return this.model.id;
		},

		onRender: function() {
			this.refresh();
		},

		showDashMenu: function() {
			return this.isOwner() || this.canBeDeleted();
		}
	});
});

